import React from "react";

const Loader = () => {
  return (
    <div className="border-solid border-4 border-[#f3f3f3] rounded-[50%] border-t-4 border-t-[#3498db] w-[60px] h-[60px] animate-spin "></div>
  );
};

export default Loader;
